<svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_6882_8415)">
<path d="M37.2 2.61658C38.9327 1.61624 41.0674 1.61624 42.8 2.61658L71.841 19.3834C73.5737 20.3838 74.641 22.2325 74.641 24.2332V57.7668C74.641 59.7675 73.5737 61.6162 71.841 62.6166L42.8 79.3834C41.0674 80.3838 38.9327 80.3838 37.2 79.3834L8.15899 62.6166C6.42634 61.6162 5.35899 59.7675 5.35899 57.7668V24.2332C5.35899 22.2325 6.42634 20.3838 8.15899 19.3834L37.2 2.61658Z" fill="url(#paint0_linear_6882_8415)"/>
<g filter="url(#filter1_ddd_6882_8415)">
<path d="M37.2 6.9834C38.9327 5.98306 41.0674 5.98306 42.8 6.9834L68.0593 21.5668C69.7919 22.5672 70.8593 24.4159 70.8593 26.4166V55.5835C70.8593 57.5842 69.7919 59.4329 68.0593 60.4332L42.8 75.0167C41.0674 76.017 38.9327 76.017 37.2 75.0167L11.9408 60.4332C10.2081 59.4329 9.14077 57.5842 9.14077 55.5835V26.4166C9.14077 24.4159 10.2081 22.5672 11.9408 21.5668L37.2 6.9834Z" fill="url(#paint1_linear_6882_8415)"/>
</g>
<g filter="url(#filter2_dd_6882_8415)">
<path d="M37.32 11.1774C39.0491 10.1826 41.1768 10.1826 42.9058 11.1774L64.617 23.67C66.3536 24.6693 67.4241 26.5202 67.4241 28.5238V53.4762C67.4241 55.4798 66.3536 57.3308 64.617 58.33L42.9058 70.8226C41.1768 71.8175 39.0491 71.8175 37.32 70.8226L15.6089 58.33C13.8723 57.3308 12.8018 55.4798 12.8018 53.4762V28.5238C12.8018 26.5202 13.8723 24.6693 15.6089 23.67L37.32 11.1774Z" fill="url(#paint2_linear_6882_8415)"/>
<path d="M38.118 12.5642C39.353 11.8536 40.8728 11.8536 42.1079 12.5642L63.819 25.0568C65.0594 25.7706 65.8241 27.0927 65.8241 28.5238V53.4762C65.8241 54.9074 65.0594 56.2295 63.819 56.9432L42.1079 69.4358C40.8728 70.1464 39.353 70.1464 38.118 69.4358L16.4069 56.9432C15.1664 56.2295 14.4018 54.9074 14.4018 53.4762V28.5238C14.4018 27.0927 15.1664 25.7706 16.4069 25.0568L38.118 12.5642Z" stroke="url(#paint3_linear_6882_8415)" stroke-width="3.2"/>
</g>
</g>
<g filter="url(#filter3_d_6882_8415)">
<mask id="mask0_6882_8415" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="24" y="29" width="32" height="27">
<path d="M38.4171 54.7147C39.2641 55.6522 40.7358 55.6522 41.5829 54.7147L55.313 39.5187C55.9794 38.7812 56.0481 37.6812 55.4787 36.8664L50.8045 30.1779C50.4054 29.6068 49.7526 29.2666 49.0558 29.2666H30.9441C30.2474 29.2666 29.5945 29.6068 29.1954 30.1779L24.5212 36.8664C23.9518 37.6812 24.0206 38.7812 24.6869 39.5187L38.4171 54.7147Z" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_6882_8415)">
<path d="M40 56.4666L56.4516 38.2585L50.1676 29.2666H29.8323L23.5483 38.2585L40 56.4666Z" fill="#D9D9D9"/>
<path d="M39.9999 56.4666L50.1676 29.2666H29.8323L39.9999 56.4666Z" fill="url(#paint4_linear_6882_8415)"/>
<path d="M56.4516 38.2585L50.1676 29.2666H29.8323L23.5483 38.2585H56.4516Z" fill="#C8CACC"/>
<path d="M33.1948 38.2585L40 29.2666H29.8323L23.5483 38.2585H33.1948Z" fill="url(#paint5_linear_6882_8415)"/>
<path d="M46.8051 38.2585L39.9999 29.2666H50.1676L56.4515 38.2585H46.8051Z" fill="#A8ABAE"/>
<path d="M40 56.4666L29.8323 29.2666L23.5483 38.2585L40 56.4666Z" fill="#C8CACC"/>
<path d="M33.1936 38.2585L29.8323 29.2666L23.5483 38.2585H33.1936Z" fill="#E9EAEA"/>
<path d="M40 56.4666L50.1677 29.2666L56.4517 38.2585L40 56.4666Z" fill="url(#paint6_linear_6882_8415)"/>
<path d="M46.8063 38.2585L50.1676 29.2666L56.4515 38.2585H46.8063Z" fill="#C8CACC"/>
</g>
</g>
<g style="mix-blend-mode:color">
<path d="M37.2 2.61658C38.9327 1.61624 41.0674 1.61624 42.8 2.61658L71.841 19.3834C73.5737 20.3838 74.641 22.2325 74.641 24.2332V57.7668C74.641 59.7675 73.5737 61.6162 71.841 62.6166L42.8 79.3834C41.0674 80.3838 38.9327 80.3838 37.2 79.3834L8.15899 62.6166C6.42634 61.6162 5.35899 59.7675 5.35899 57.7668V24.2332C5.35899 22.2325 6.42634 20.3838 8.15899 19.3834L37.2 2.61658Z" fill="#FFF1C1"/>
</g>
<g style="mix-blend-mode:soft-light">
<path d="M37.2 2.61658C38.9327 1.61624 41.0674 1.61624 42.8 2.61658L71.841 19.3834C73.5737 20.3838 74.641 22.2325 74.641 24.2332V57.7668C74.641 59.7675 73.5737 61.6162 71.841 62.6166L42.8 79.3834C41.0674 80.3838 38.9327 80.3838 37.2 79.3834L8.15899 62.6166C6.42634 61.6162 5.35899 59.7675 5.35899 57.7668V24.2332C5.35899 22.2325 6.42634 20.3838 8.15899 19.3834L37.2 2.61658Z" fill="#FFBFBF" fill-opacity="0.6"/>
</g>
<defs>
<filter id="filter0_d_6882_8415" x="2.98568" y="0.559666" width="74.0286" height="83.014" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.06667"/>
<feGaussianBlur stdDeviation="1.18667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_8415"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6882_8415" result="shape"/>
</filter>
<filter id="filter1_ddd_6882_8415" x="7.03408" y="4.12649" width="66.8385" height="73.8538" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="1.05333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_8415"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1.06667" dy="0.266667"/>
<feGaussianBlur stdDeviation="0.973333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_6882_8415" result="effect2_dropShadow_6882_8415"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.06667"/>
<feGaussianBlur stdDeviation="0.533333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="effect2_dropShadow_6882_8415" result="effect3_dropShadow_6882_8415"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_6882_8415" result="shape"/>
</filter>
<filter id="filter2_dd_6882_8415" x="10.3219" y="7.95127" width="59.5822" height="66.0975" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="1.24"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_8415"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.533333"/>
<feGaussianBlur stdDeviation="0.733333"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_6882_8415" result="effect2_dropShadow_6882_8415"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_6882_8415" result="shape"/>
</filter>
<filter id="filter3_d_6882_8415" x="22.0031" y="27.6666" width="35.9936" height="30.4179" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.533333"/>
<feGaussianBlur stdDeviation="1.06667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6882_8415"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6882_8415" result="shape"/>
</filter>
<linearGradient id="paint0_linear_6882_8415" x1="0" y1="1" x2="79.7284" y2="81.2698" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#92969A"/>
</linearGradient>
<linearGradient id="paint1_linear_6882_8415" x1="4.36682" y1="5.36682" x2="75.3913" y2="76.8736" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D8286"/>
<stop offset="1" stop-color="#C8CACC"/>
</linearGradient>
<linearGradient id="paint2_linear_6882_8415" x1="16.4827" y1="17.4496" x2="71.4624" y2="72.6157" gradientUnits="userSpaceOnUse">
<stop stop-color="#C8CACC"/>
<stop offset="1" stop-color="#5A6066"/>
</linearGradient>
<linearGradient id="paint3_linear_6882_8415" x1="16.4827" y1="17.4496" x2="73.9358" y2="75.0975" gradientUnits="userSpaceOnUse">
<stop stop-color="#A8ABAE"/>
<stop offset="1" stop-color="#5A6066"/>
</linearGradient>
<linearGradient id="paint4_linear_6882_8415" x1="35.8035" y1="37.5037" x2="49.6483" y2="61.3537" gradientUnits="userSpaceOnUse">
<stop stop-color="#92969A"/>
<stop offset="1" stop-color="#C8CACC"/>
</linearGradient>
<linearGradient id="paint5_linear_6882_8415" x1="29.9937" y1="27.2054" x2="35.9349" y2="36.2361" gradientUnits="userSpaceOnUse">
<stop stop-color="#E9EAEA"/>
<stop offset="1" stop-color="#A8ABAE"/>
</linearGradient>
<linearGradient id="paint6_linear_6882_8415" x1="43.5756" y1="39.5465" x2="58.48" y2="52.7343" gradientUnits="userSpaceOnUse">
<stop stop-color="#7D8286"/>
<stop offset="1" stop-color="#C8CACC"/>
</linearGradient>
</defs>
</svg>
